import React, { ReactNode } from 'react';
import Dropzone from 'react-dropzone';

import { DropContainer, UploadMessage } from './styles';

interface UploadProps {
  onUpload: Function;
  accept?: any;
  label?: string;
  multiple?: boolean;
}

const Upload = ({ onUpload, label, accept, multiple }: UploadProps) => {
  function renderDragMessage(
    isDragActive: boolean,
    acceptedFiles: any,
  ): ReactNode {
    const maxSize = 5000000;
    const isFileTooLarge =
      acceptedFiles.length > 0 && acceptedFiles[0].size > maxSize;

    if (!isDragActive) {
      return <UploadMessage>Clique ou arraste o arquivo aqui.</UploadMessage>;
    }

    if (isFileTooLarge) {
      return (
        <UploadMessage type="error">
          Arquivo maior que o permitido
        </UploadMessage>
      );
    }

    return <UploadMessage type="success">Solte o arquivo aqui</UploadMessage>;
  }

  return (
    <>
      <Dropzone
        accept={accept ? accept : 'application/*, text/*, image/*'}
        onDropAccepted={files => onUpload(files)}
        multiple={multiple ? multiple : false}
        minSize={0}
        maxSize={5000000}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragReject,
          acceptedFiles,
        }): any => {
          return (
            <DropContainer
              {...getRootProps()}
              isDragActive={isDragActive}
              isDragReject={isDragReject}
            >
              <input {...getInputProps()} data-testid="upload" />
              {renderDragMessage(isDragActive, acceptedFiles)}
            </DropContainer>
          );
        }}
      </Dropzone>
    </>
  );
};

export default Upload;
